.error {
  font-size: var(--font-size-xs);
  color: var(--color-error-text);
}
